import styled from "styled-components";
import { Link } from "react-router-dom";

export const CustomLink = styled(Link)`
  font-size: 15px;
`;
